import { useContext } from 'react';
import { Button, Grid, Table, TableBody, TableCell, TableFooter, TableHead, TableRow, Typography } from '@material-ui/core';
import Moment from 'react-moment';
import { DeleteIconButton } from 'components';
import { resolutionsContext } from '../ResolutionsContext';
import DefectiveComponentEditor from './DefectiveComponentEditor';

interface IProps {
    isReadOnly: boolean
}

let DefectiveComponents = (props: IProps) => {
    let service = useContext(resolutionsContext);

    return (
        <Grid item xs={12}>
            <Grid container alignItems='center' style={{ backgroundColor: '#efefef' }}>
                <Grid item xs>
                    <Typography variant="h5">Defective components</Typography>
                </Grid>
                {props.isReadOnly === false && service.defectiveComponents.length !== 0 &&
                    <Grid item>
                        <Button
                            color="secondary"
                            size="small"
                            variant="text"
                            onClick={async () => await service.defectiveComponentListCompleted()}
                        >
                            List completed
                        </Button>
                    </Grid>
                }
            </Grid>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Product</TableCell>
                        <TableCell align="right">Quantity</TableCell>
                        <TableCell>Created By</TableCell>
                        <TableCell>Created On</TableCell>
                        {props.isReadOnly === false &&
                            <TableCell align="right">
                                <DefectiveComponentEditor />
                            </TableCell>
                        }
                    </TableRow>
                </TableHead>
                <TableBody>
                    {service.defectiveComponents.map(res =>
                        <TableRow key={res.id}>
                            <TableCell>{res.productSKU}&nbsp;{res.productDescription}</TableCell>
                            <TableCell align="right">{res.quantity}</TableCell>
                            <TableCell>{res.createdBy}</TableCell>
                            <TableCell>
                                <Moment date={res.createdOn} format="ll" />
                            </TableCell>
                            {props.isReadOnly === false &&
                                <TableCell style={{ whiteSpace: 'nowrap' }} align="right">
                                    <DefectiveComponentEditor defectiveComponent={res} />
                                    <DeleteIconButton onClick={async () => await service.deleteDefectiveComponent(res.id)} />
                                </TableCell>
                            }
                        </TableRow>
                    )}
                </TableBody>
                {service.defectiveComponents.length === 0 &&
                    <TableFooter>
                        <TableRow>
                            <TableCell colSpan={props.isReadOnly === false ? 5 : 4}><i>No defective component found</i></TableCell>
                        </TableRow>
                    </TableFooter>
                }
            </Table>
        </Grid>
    )
}

export default DefectiveComponents;